import { Component } from "@angular/core";
import {
  AlertController,
  IonicPage,
  NavController,
  NavParams,
} from "ionic-angular";
import { Api } from "../../services/api";
import { AlertIfDebugging, Util } from "../../services/util";
import { User } from "../../services/user";
import { sharedData } from "../../services/vars";
import { Purchase } from "../../services/purchase";
import { BindAccountPage } from "../bind-account/bind-account";
import { Poster } from "../../services/poster";
import { WeixinQr } from "../../services/weixin_qr";
import { ShareCard } from "../../services/sharecard";

/**
 * Generated class for the CampaignDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "campaign/:id",
})
@Component({
  selector: "page-campaign-detail",
  templateUrl: "campaign-detail.html",
})
export class CampaignDetailPage {
  data;
  carouselImages = [];
  myParticipation;
  countdown = { hours: "--", minutes: "--", seconds: "--" };
  resolveDataReady;
  dataReadyResolved = false;
  organizerSpecialCashRewards = null;
  dataReadyPromise = new Promise((resolve) => {
    this.resolveDataReady = resolve;
  });

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private api: Api,
    private util: Util,
    private alertCtrl: AlertController,
    private user: User,
    private purchase: Purchase,
    public poster: Poster,
    public weixinQr: WeixinQr,
    public shareCard: ShareCard
  ) {}

  ionViewWillUnload() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = 0;
    }
  }

  limitArraySize(arr, limit) {
    if (!arr || arr.length < limit) {
      return arr;
    }
    return arr.slice(0, limit);
  }

  getVerb() {
    if (this.data.campaign_type === 1 || this.data.campaign_type === 2) {
      if (this.data.primary_group_buy_campaign === 0) {
        return "发起";
      } else {
        return "参与";
      }
    } else {
      return "发起";
    }
  }

  getDesc() {
    if (this.data.is_solo) {
      return "单独购买";
    }
    if (
      this.data.campaign_type === 1 ||
      this.data.campaign_type === 2 ||
      this.data.campaign_type === 3
    ) {
      return "拼团";
    } else {
      return "砍价";
    }
  }

  private setWeixinShareMessage() {
    let title = this.data.item.name;
    if (this.data.campaign_type !== 3) {
      title += " - " + this.data.user.name + "发起的" + this.getDesc() + "活动";
    }
    let desc = "快来一起参与";
    if (this.data.campaign_type === 0) {
      desc = "快来帮TA一起砍价";
    }
    if (this.data.campaign_type === 1) {
      desc = "快来和我一起拼团";
    }
    this.shareCard.share({
      title: title,
      desc: desc,
      link: location.href,
      imgUrl: this.data.item.image_url,
    });
  }

  isGroupBuyExpired = false;

  private calcCountdown() {
    let elapsedSeconds =
      +new Date() / 1000 - this.data.primary_campaign_started_at;
    let totalSeconds = this.data.item.group_buy_mode_hours_limit * 3600;
    let remainingSeconds = totalSeconds - elapsedSeconds;
    if (!this.data.item.group_buy_mode_hours_limit) {
      remainingSeconds =
        (this.data.item.group_buy_mode_expire_time - +new Date()) / 1000;
    }
    if (remainingSeconds < 0) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = 0;
      this.isGroupBuyExpired = true;
    }
    if (this.data.state !== 0) {
      this.isGroupBuyExpired = true;
    }
    this.countdown = {
      hours: Math.floor(remainingSeconds / 3600)
        .toFixed(0)
        .padStart(2, "0"),
      minutes: Math.floor((remainingSeconds / 60) % 60)
        .toFixed(0)
        .padStart(2, "0"),
      seconds: Math.floor(remainingSeconds % 60)
        .toFixed(0)
        .padStart(2, "0"),
    };
  }

  joinExistingCampaign(campaign) {
    window.location.hash = "/campaign/" + campaign.id;
  }

  countdownTimer = 0;

  private fetchData(showLoading = true) {
    this.api
      .getCampaignDetail(this.navParams.data.id, showLoading)
      .then((data) => {
        this.data = data;

        if (this.data.state == 1) {
          this.api.getItemDetail(this.data.item.id).then((x) => {
            this.data.ongoingCampaigns = x.ongoingCampaigns;
            (this.data.ongoingCampaigns || []).forEach((camp) => {
              camp.group_buy_wanted_participants_count =
                this.data.item.group_buy_mode_participants_required -
                camp.group_buy_paid_participants_count;
            });
          });
        }
        if (data.item.descending_price_specs) {
          data.item.descendingPriceSpecs = JSON.parse(
            data.item.descending_price_specs
          );
          data.item.descendingPriceSpecs.unshift({
            at: 0,
            price: data.item.price,
          });
        }
        if (data.item.organizer_special_cash_rewards) {
          data.item.organizerSpecialCashRewards = JSON.parse(
            data.item.organizer_special_cash_rewards
          );
        }

        this.data.is_mine = this.data.user_id === this.user.id;
        this.data.group_buy_participants =
          this.data.group_buy_participants || [];
        const all_campaigns = JSON.parse(
          JSON.stringify(this.data.group_buy_participants)
        ).sort((a, b) => a.campaign_id - b.campaign_id);
        this.data.place_at_groupbuy = 0;
        all_campaigns.forEach((item, idx) => {
          if (item.campaign_id == this.navParams.data.id) {
            this.data.place_at_groupbuy = idx + 1;
            if (data.item.organizerSpecialCashRewards) {
              data.item.organizerSpecialCashRewards.forEach((item) => {
                if (
                  item.number_from <= this.data.place_at_groupbuy &&
                  item.number_to >= this.data.place_at_groupbuy
                ) {
                  this.organizerSpecialCashRewards = item;
                  let lastOneIsOk = true;
                  this.organizerSpecialCashRewards.rewards.forEach((level) => {
                    if (this.data.group_buy_participants.length >= level.at) {
                      level.finished = true;
                      lastOneIsOk = true;
                    } else {
                      if (lastOneIsOk) {
                        lastOneIsOk = false;
                        level.nextOne = true;
                      }
                    }
                  });
                }
              });
            }
          }
        });
        this.myParticipation = (this.data.participations || []).find(
          (_) => _.user_id === this.user.id
        );
        this.carouselImages = this.util.getCarouselImages(
          data.item.image_url,
          data.item.carousel_images
        );
        if (this.data.campaign_type === 3) {
          document.title = data.item.name;
        } else {
          document.title =
            data.item.name +
            " - " +
            this.data.user.name +
            "的" +
            this.getDesc() +
            "活动";
        }

        if (
          this.data.campaign_type === 1 ||
          this.data.campaign_type === 2 ||
          this.data.campaign_type === 3
        ) {
          // 拼团模式，添加倒计时
          if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = 0;
          }
          this.countdownTimer = setInterval(
            this.calcCountdown.bind(this),
            1000
          );
          this.calcCountdown();
        }

        this.setWeixinShareMessage();
        if (!this.dataReadyResolved) {
          this.dataReadyResolved = true;
          this.resolveDataReady();
        }
      });
  }

  showParticipant(participant) {
    if (participant.name && participant.name.trim()) {
      this.util.showToast(participant.name + " 参与了本活动");
    }
  }

  participate() {
    if (this.data.campaign_type === 0) {
      this.api.participateInCampaign(this.data.id).then((_) => {
        this.alertCtrl
          .create({
            title: "恭喜，砍价成功",
            subTitle: "您成功砍下了<b>" + _.price_cut / 100 + "</b>元",
            enableBackdropDismiss: false,
            cssClass: "participation-success-modal",
            buttons: [
              {
                text: "关闭",
                role: "cancel",
              },
              {
                text: "发起我的专属砍价活动",
                handler: (data) => {
                  this.createMine();
                },
              },
            ],
          })
          .present();
        this.fetchData(false);
      });
    } else if (this.data.campaign_type === 1) {
      // 拼团
    }
  }

  ionViewDidLoad() {
    this.api.collect({
      event: "view-campaign",
      attr: { id: this.navParams.data.id },
    });
    this.fetchData();

    window["refreshCampaign"] = () => this.fetchData(false);
  }

  max(a, b) {
    if (a > b) {
      return a;
    } else {
      return b;
    }
  }

  ionViewDidEnter() {
    let promises = [() => this.dataReadyPromise];
    if (!this.data) {
      document.title = "加载中……";
    } else {
      document.title =
        this.data.item.name + " - " + this.data.user.name + "发起的砍价活动";
      this.setWeixinShareMessage();
    }

    if (sharedData.showCampaignCreatedFlag) {
      promises.push(() => this.showMineCreated());
      sharedData.showCampaignCreatedFlag = false;
    }

    if (sharedData.showShareGuideFlag) {
      promises.push(() => this.showShareInstructions());
      sharedData.showShareGuideFlag = false;
    }

    (async () => {
      for (let promise of promises) {
        await promise();
      }
    })();
  }

  showAlreadyParticipatedHint() {
    this.util.showToast("您已经砍过价啦");
  }

  createMine() {
    this.api
      .createCampaign({
        itemId: this.data.item.id,
      })
      .then((campaign) => {
        if (!this.data.ihave) {
          sharedData.showCampaignCreatedFlag = true;
          sharedData.showShareGuideFlag = true;
        }
        window.location.hash = "/campaign/" + campaign.id;
      });
  }

  isOngoing() {
    if (this.data.price_cut >= this.data.item.max_price_cut) {
      return false;
    }
    if (this.data.state == 1) {
      return false;
    }
    return true;
  }

  showPurchase() {
    if (!window["UserService"].isLoggedIn()) {
      window["UserService"].showLogin();
      return;
    }
    if (!window["UserService"].user_center_user_id) {
      this.util.showToast("请先完成手机号绑定，再进行购买");
      window["bindAccountCallback"] = this.showPurchase.bind(this);
      this.navCtrl.push(BindAccountPage);
      return;
    }
    this.purchase.purchaseCampaign(this.data.id);
  }

  showItemDetail() {
    window.location.hash = "/item/" + this.data.item.id;
  }

  showCashReward() {
    window.location.hash = "/campaign-cash-reward/" + this.navParams.data.id;
  }

  showShareInstructions() {
    this.api.collect({
      event: "show-share-instructions",
      attr: { id: this.navParams.data.id },
    });
    return new Promise((res) => {
      this.alertCtrl
        .create({
          title: "分享给朋友",
          subTitle:
            "点击右上角图标，即可把本页面分享给微信好友，邀请他们一起来" +
            this.getDesc(),
          enableBackdropDismiss: false,
          buttons: [
            {
              text: "好",
              handler: res,
            },
          ],
        })
        .present();
    });
  }

  showMineCreated() {
    return new Promise((res) => {
      this.alertCtrl
        .create({
          title: "创建成功",
          subTitle: "恭喜，系统已经为您创建您的专属页面",
          enableBackdropDismiss: false,
          buttons: [
            {
              text: "好",
              handler: res,
            },
          ],
        })
        .present();
    });
  }

  showOrderDetail() {
    let campId = this.data.id;
    if (!this.data.is_mine) {
      campId = this.data.group_buy_participants.filter(
        (_) => _.id === window["UserService"].id
      )[0].campaign_id;
    }
    window.location.hash = "/order/" + campId;
  }

  joinGroupBuy() {
    if (!window["UserService"].isLoggedIn()) {
      window["UserService"].showLogin();
      return;
    }
    if (!window["UserService"].user_center_user_id) {
      this.util.showToast("请先完成手机号绑定，再进行购买");
      window["bindAccountCallback"] = this.joinGroupBuy.bind(this);
      this.navCtrl.push(BindAccountPage);
      return;
    }
    const isDescendingGroupBuy = this.data.item.campaign_type === 2;
    const isGlobalGroupBuy = this.data.item.campaign_type === 3;
    this.purchase.joinGroupBuy(
      this.data.item.id,
      this.data.primary_group_buy_campaign || this.data.id,
      this.data.item.group_buy_mode_participants_required -
        this.data.group_buy_participants.length ==
        1,
      isDescendingGroupBuy,
      isGlobalGroupBuy,
      null
    );
  }

  isInGroupBuy() {
    if (!window["UserService"] || !window["UserService"].id) {
      return false;
    }
    return this.data.group_buy_participants.some(
      (_) => _.id === window["UserService"].id
    );
  }

  groupBuyBottomBarClick() {
    if (this.isInGroupBuy()) {
      // share
      this.showShareInstructions();
    } else {
      // join
      this.joinGroupBuy();
    }
  }

  getCutPrice() {
    if (this.data.campaign_type === 0) {
      // 砍价
      return (this.data.item.price - this.data.price_cut) / 100;
    } else if (this.data.campaign_type === 1 || this.data.campaign_type === 3) {
      // 拼团
      if (this.data.is_solo) {
        if (this.data.real_expenditure_amount > 0) {
          return this.data.real_expenditure_amount / 100;
        }
        return this.data.item.solo_price / 100;
      } else {
        return (this.data.item.price - this.data.item.max_price_cut) / 100;
      }
    } else if (this.data.campaign_type === 2) {
      // descending group buy
      let lastPrice = this.data.item.price;
      this.data.item.descendingPriceSpecs.forEach((level) => {
        if (this.data.group_buy_participants.length < level.at) {
          return;
        }
        lastPrice = level.price;
      });
      return lastPrice / 100;
    }
  }

  getDescendingGroupDesc() {
    //  人数越多，价格越低
    for (let i = 0; i < this.data.item.descendingPriceSpecs.length; i++) {
      if (
        this.data.item.descendingPriceSpecs[i].price / 100 ==
        this.getCutPrice()
      ) {
        if (i == this.data.item.descendingPriceSpecs.length - 1) {
          return "已成功达到底价！";
        } else {
          let s = `还`;
          let diff =
            this.data.item.descendingPriceSpecs[i + 1].at -
            this.data.group_buy_participants.length;
          if (diff <= 8) {
            s = "仅";
          }
          return `距离下一档¥${
            this.data.item.descendingPriceSpecs[i + 1].price / 100
          }，${s}差${diff}人（到达下一档后会立刻通过微信红包返还差价）`;
        }
      }
    }
    return "人数越多，价格越低";
  }

  showInvitePoster() {
    this.poster.show(this.data.item.id, this.data.item.tenant_id);
  }

  showWeixinQr() {
    return this.weixinQr.show(this.data.item.qr_url, this.data.item.name);
  }
}



// WEBPACK FOOTER //
// ./src/pages/campaign-detail/campaign-detail.ts